import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { variables } from './Variables.js';
export default function Latest_Ar() {
  const jsonUrl = variables.basename_url + 'updates/index/Coinsinsight_HomeAR_TrendingNews.json';
  const [isLoading, setNisLoading] = useState(false);
   const [JsonArray, setJsonArray] = React.useState([]);
  async function refda() {
    setNisLoading(true);
    //  To Show or Hidden Header And Footer
    document.getElementById('Arabic_Header').hidden = false;
    document.getElementById('Arabic_Footer').hidden = false;
    Get_Data();
  }
  async function Get_Data() {
    JsonArray.splice(0);  //to clear All data in your page
    setNisLoading(true);
    axios.get(jsonUrl)
      .then(function (response) {
        setNisLoading(false);
        console.log(response.data);
        for (let i = 0; i <= 4 && i < response.data.length; i++) {
          JsonArray.push({
            news_title: response.data[i].news_title,
            news_date: response.data[i].news_date.split('T')[0],
            news_imagename: response.data[i].image,
            link: response.data[i].link,
            Description: response.data[i].Description.replace("https://menafn.com/", variables.domain_name + "/").replace("https://menafn.com", variables.domain_name).replace("MENAFN", variables.domain).replace("MENAFN", variables.domain),

            Category: response.data[i].Category,
          })
        }
      })
  }
  useEffect(() => {
    setNisLoading(true);

    refda();
  }, [])
  return (
    <>
      {JsonArray.map(da =>
        <div key={da.news_title}  >
          <div className="post-gallery-style-2 most-view-style-2">
            <div className="post-gallery-content">
              <h5 className="title Arabic-text"><a href={da.link} tabIndex={-1}>{da.news_title}</a></h5>
              <div className="meta-post-2-style">
                <div className="meta-post-categores">
                  <a href="#" tabIndex={-1}>{da.Category}</a>
                </div>
              </div>
            </div>
            <div className="post-gallery-thumb">
              <a href={da.link}>
                <img style={{ maxWidth: '100%', maxHeight: '57px', minHeight: '57px' }} className='rounded' src={da.news_imagename} alt="gallery" />
              </a>
            </div>
          </div>
          <div></div>
        </div>
      )}
    </>
  );
}



